import React from 'react';
import { cn } from '../../lib/utils';

const buttonVariants = {
  default: 'bg-[var(--brand-primary,#1A428A)] text-white hover:bg-[#163872] shadow-sm',
  secondary: 'bg-slate-100 text-slate-900 hover:bg-slate-200',
  outline: 'border border-slate-200 bg-white text-slate-900 hover:bg-slate-50',
  ghost: 'bg-transparent text-slate-700 hover:bg-slate-100'
};

export function Button({ className, variant = 'default', size = 'md', type = 'button', ...props }) {
  const sizeClasses = {
    sm: 'h-8 px-3 text-sm',
    md: 'h-10 px-4 text-sm',
    lg: 'h-11 px-5 text-sm'
  };

  return (
    <button
      type={type}
      className={cn(
        'inline-flex items-center justify-center rounded-sm font-semibold transition duration-150',
        'hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary,#1A428A)]/20',
        'disabled:pointer-events-none disabled:opacity-50 disabled:hover:scale-100',
        buttonVariants[variant],
        sizeClasses[size],
        className
      )}
      {...props}
    />
  );
}
